import { Auth } from 'aws-amplify';
import React, { useContext } from 'react';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import ChangePassword from './ChangePassword';
import { ShipyardContext } from '../Context';
import Step1 from './ForgotPassword/Step1';
import Step2 from './ForgotPassword/Step2';

import './ForgotPassword.scss';

function ForgotPassword() {
    const { userSettings } = useContext(ShipyardContext);
    const [t] = useTranslation();
    const [doingAjax, setDoingAjax] = React.useState(false);
    const [step, setStep] = React.useState(1);
    const [email, setEmail] = React.useState();
    const [verificationCode, setVerificationCode] = React.useState();

    const history = useHistory();

    const handleRetryEmail = () => {
        setStep(1);
    };

    const handleSubmitEmail = (enteredEmail) => {
        setDoingAjax(true);
        Auth.forgotPassword(enteredEmail)
            .then(() => {
                setDoingAjax(false);
                setEmail(enteredEmail);
                setStep(2);
            })
            .catch((err) => {
                setDoingAjax(false);
                if (err.name === 'LimitExceededException') {
                    toast.error(t('Authentication.TooManyResetAttempts'));
                }
            });
    };

    const handleSubmitVerificationCode = (code) => {
        setVerificationCode(code);
        setStep(3);
    };

    const handleSubmitNewPassword = (pwd) => {
        setDoingAjax(true);
        Auth.forgotPasswordSubmit(email, verificationCode, pwd)
            .then((data) => {
                setDoingAjax(false);
                if (data === 'SUCCESS') {
                    toast.success(t('Authentication.PasswordChanged'));
                    history.push('/signin');
                    return;
                }
                toast.error(t('Authentication.PasswordChangeError'));
                console.error('Shipyard: Unrecognized response', data);
                setStep(1);
            })
            .catch((err) => {
                if (err.name === 'CodeMismatchException') {
                    toast.error(t('Authentication.VerificationCodeIncorrect'));
                    setDoingAjax(false);
                    setStep(2);
                    return;
                }
                if (err.name === 'InvalidPasswordException') {
                    toast.error(t('Authentication.PasswordWeak'));
                    setDoingAjax(false);
                    return;
                }
                console.error('Shipyard: Unhandled error in handleSubmitNewPassword', err);
                setDoingAjax(false);
                setStep(1);
            });
    };

    return (
        <div id="page-forgot-password">
            <div id="page-forgot-password-foreground">
                <h1>
                    <img
                        alt="Client Header"
                        src={userSettings.ClientHeaderImage || '/pcg-scholar.svg'}
                    />
                </h1>
                {step === 1 && (
                    <Step1
                        callback={handleSubmitEmail}
                        disabled={doingAjax}
                    />
                )}
                {step === 2 && (
                    <Step2
                        callback={handleSubmitVerificationCode}
                        cancelCallback={handleRetryEmail}
                        disabled={doingAjax}
                    />
                )}
                {step === 3 && (
                    <ChangePassword
                        callback={handleSubmitNewPassword}
                        disabled={doingAjax}
                    />
                )}
            </div>
            <div id="page-forgot-password-background" />
        </div>
    );
}

export default ForgotPassword;
